const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const ssoHost = publicConfig.external_address;

exports.Invoices = {
  // fetches invoice entries related to VAT (tax)
  fetchBkgInvoiceEntries: (accessToken, ssoId, bookingId, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/journal/fees-journal/invoices/entries/user/${ssoId}/control/${bookingId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },

  fetchInvoiceEntriesByType: (token, invoiceId, txnType, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/journal/fees-journal/invoices/entries/invoice/${invoiceId}/type/${txnType}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    });
  }
};
